/* eslint-disable */
import { Component } from 'react';
import { isTrue } from '../../../../helpers/isTrue';

class Users extends Component {
    constructor() {
        super();
        this.linkedAccounts = window.linkedAccounts ?? [];
        this.user_data = window.user_data ?? {};
        this.viewers = window.viewers ?? [];
        try {
            this.permission_errors = JSON.parse(this.props.permission_errors) ?? [];
        } catch (err) {
            this.permission_errors = [];
        }
    }

    render() {
        return (
            <div className="settings-card settings-linked-accounts">
                <div className="settings-linked-accounts-header">
                    <div className="d-flex align-items-center">
                        Users
                        <div className="settings-domains-tag">
                            {this.props.user_viewers_count} of {this.props.available_viewers} seats
                            used
                        </div>
                    </div>
                    <div className="d-flex gap-8">
                        <a
                            href="/tools/purchase-more-entity/?part=seats"
                            className="button button-filled button-primary"
                        >
                            Buy Additional Seats
                        </a>
                        {!isTrue(this.props.is_deactivated) && (
                            <a
                                href="/customers/add-user"
                                className="button button-filled button-primary"
                            >
                                Add User
                            </a>
                        )}
                    </div>
                </div>
                <div className="settings-linked-accounts-body">
                    <div className="settings-linked-accounts-item">
                        <div className="settings-linked-accounts-item-left">
                            <div className="settings-icon-first-letter">
                                {this.user_data?.first_latter}
                            </div>
                            <div className="settings-linked-accounts-item-left-text">
                                <div>{this.user_data.full_name} (Owner)</div>
                                {this.user_data?.client_email && (
                                    <div className="settings-linked-accounts-item-left-text-bottom ">
                                        {this.user_data?.client_email}{' '}
                                    </div>
                                )}
                            </div>
                        </div>
                        {!isTrue(this.props.is_deactivated) && (
                            <a
                                href="/customers/change_customer_profile"
                                className="settings-action-btn"
                            >
                                <i className="icon-edit"></i>
                            </a>
                        )}
                    </div>
                    {!!this.viewers.length &&
                        this.viewers?.map((item, i) => (
                            <div key={i} className="settings-linked-accounts-item">
                                <div className="settings-linked-accounts-item-left">
                                    <div className="settings-icon-first-letter">
                                        {item?.first_latter}
                                    </div>
                                    <div className="settings-linked-accounts-item-left-text">
                                        <div>{item.full_name}</div>
                                        {item.client_email && (
                                            <div className="settings-linked-accounts-item-left-text-bottom users">
                                                {item.client_email}{' '}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {!isTrue(this.props.is_deactivated) && (
                                    <div className="settings-linked-accounts-action-btns">
                                        {isTrue(item.active) ? (
                                            <a href={`/customers/deactivate-user/${item.id}`}>
                                                <span className={`switch-button active`}>
                                                    <span className="switch-circle"></span>
                                                </span>
                                            </a>
                                        ) : (
                                            <a href={`/customers/reactivate-user/${item.id}`}>
                                                <span className={`switch-button not-active`}>
                                                    <span className="switch-circle" />
                                                </span>
                                            </a>
                                        )}
                                        <a
                                            href={`/customers/edit-user/${item.id}`}
                                            className="settings-action-btn"
                                        >
                                            <i className="icon-edit"></i>
                                        </a>
                                        <a
                                            href={`/customers/delete-user/${item.id}`}
                                            className="settings-action-btn"
                                        >
                                            <i className="icon-delete"></i>
                                        </a>
                                    </div>
                                )}
                            </div>
                        ))}
                </div>
            </div>
        );
    }
}

export default Users;
